import React, { useCallback, useContext, useEffect, useState } from "react";
import moengage from "@moengage/web-sdk";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/advance/Loading";
import Modal from "../../components/advance/Modal";
// import Button from "../../components/core/Button";
import Button from "../../components/core/EPL_Button_Think";
import ErrorModal from "../../modals/ErrorModal";
import { UserContext } from "../../shared/context/UserContext";
// import useMediaQuery from '../../shared/hooks/useMediaQuery';
import useMediaQuery from "../../hooks/useMediaQuery";
// import VendorService from '../../shared/services/VendorService';
// import poll from '../../shared/utils/poll';
// import sendRequest from '../../shared/utils/sendRequest';
import sendRequest from "../../utils/sendRequest";
// import { filterAddress, isValidAddress } from '../../shared/validations/Address';
// import { isValidCity } from '../../shared/validations/City';
import { isValidMobileNumber } from "../../shared/validations/MobileNumber";
import { filterName, isValidName } from "../../shared/validations/Name";
// import { isValidPincode } from '../../shared/validations/Pincode';
// import Progress from '../progress/Progress';
// import Summary from '../summary/Summary';
import { useLocation } from "react-router-dom";
import referenceTitleIcon from "../../assets/svg/EPL_think_svg/Reference_Title_Icon.svg";
import FloatingInput from "../../components/base/FloatingInput";
import Title from "../../components/core/Title";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import { encrypt } from "../../utils/crypto";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import { ReferenceDetailsWrapper } from "./_styles/ReferenceDetailsWrapper";
// import referenceArt from "../../assets/svg/EPL_think_svg/Reference_art.svg";
import SubTitle from "../../components/core/SubTitle";
import { REFERENCE_DETAILS } from "../../Config";
import { GetCustomerDetailsContext,validateInputExistenece } from "../../App";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { updateLead } from "../../shared/services/crm";
import { isStageLogin } from "../../shared/validations/StageLogin";
import { encryptedData } from "../../utils";
import CheckField from "../../components/form/CheckField";
import { userConsentStatus } from "../../utils/userConsentStatus";
moengage.initialize({app_id: 'L9SUGRVWTLEJA9UWH2ZEAMHL', cluster: 'dc_3'});

const ReferenceDetails = () => {
  // const history = useHistory();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isMobile = useMediaQuery("screen and (max-width: 768px)");

  const { user, setUser } = useContext(UserContext);
  // const applicationFormNumber = user.application_form_no;
  // const mobileNumber = String(user.mobile_number);
  const [mobileNumber, setMobile] = useState();
  // const [internalStage, setInternalStage] = useState(
  //   getInternalStage(user.Stage.stage, user.Stage.stage_status)
  // );

  const [activeAccordian, setActiveAccordian] = useState("reference_one"); // 'current_address');

  const [modal, setModal] = useState("");
  const [onSubmitButtonDisabled, setOnSubmitButtonDisabled] = useState(true);

  const dropDownLabels = [
    "Spouse",
    "Son",
    "Daughter",
    "Mother",
    "Father",
    "Brother",
    "Sister",
    "Mother in-law",
    "Father in-law",
    "Son in-law",
    "Daughter in-law",
    "Brother in-law",
    "Sister in-law",
    "Others",
  ];
  useEffect(async () => {
    isStageLogin(
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );

    setMobile(customerDetails?.Data?.mobile)
    setDropDownOptions(createDropDownOptions());
  }, []);
  const [relationStatus, setRelationStatus] = useState("");
  const [relationStatusDisabled, setRelationStatusDisabled] = useState(false);
  const [dropDownOptions, setDropDownOptions] = useState([]);

  const showDropdown = () => {
    document.getElementById("myDropdown").classList.toggle("show");
  };
  const dropDownChange = (filterText) => {
    setRelationStatus(filterText);
    setDropDownOptions(createDropDownOptions(true, filterText));
  };
  const createDropDownOptions = (isFilter = false, filterText = "") => {
    const options = [];
    for (let i = 0; i < dropDownLabels.length; i++) {
      if (
        isFilter &&
        dropDownLabels[i]?.toLowerCase().indexOf(filterText.toLowerCase()) > -1
      ) {
        options.push({
          label: dropDownLabels[i],
          value: dropDownLabels[i],
          func: () => {
            setRelationStatus(dropDownLabels[i]);
            showDropdown();
          },
        });
      } else if (!isFilter) {
        options.push({
          label: dropDownLabels[i],
          value: dropDownLabels[i],
          func: () => {
            setRelationStatus(dropDownLabels[i]);
            showDropdown();
          },
        });
      }
    }
    if (options.length === 0) {
      options.push({
        label: "Not Found",
        value: "Not Found",
        func: () => {
          filterText = "";
          isFilter = false;
          setRelationStatus("");
          showDropdown();
        },
      });
    }
    return options;
  };

  const [consentCheckbox, setConsentCheckbox] = useState(false);
  const [referenceConsent, setReferenceConsent] = useState(false)
  const [referenceThreeName, setReferenceThreeName] = useState("");
  const [referenceThreeNameError, setReferenceThreeNameError] = useState(false);
  const [referenceThreeNameErrorMessage, setReferenceThreeNameErrorMessage] = useState("Enter a valid nominee name");
  const updateReferenceThreeName = (e) => {
    let value = filterName(e.target.value);
		let nomineeName = value.replace(/\s+/g, '').toLowerCase();
    let customerName = `${customerDetails?.Data?.first_name}${customerDetails?.Data?.last_name}`.replace(/\s+/g, '').toLowerCase();
    let customerFullName = `${customerDetails?.Data?.first_name}${customerDetails?.Data?.middle_name}${customerDetails?.Data?.last_name}`.replace(/\s+/g, '').toLowerCase();

		if (isValidName(value) && nomineeName !== customerFullName && nomineeName !== customerName) {
      setReferenceThreeName(value);
      setReferenceThreeNameError(false);
    } else {
      setReferenceThreeName(value);
      setReferenceThreeNameError(true);
    }
  };

  const [nomineeMobile, setNomineeMobile] = useState("");
  const [nomineeMobileError, setNomineeMobileError] = useState(false);
  const [nomineeMobileErrorMessage, setNomineeMobileErrorMessage] = useState("Enter a valid mobile number");


  const updateNomineeMobile = (e) => {
    let mobile_number = e.target.value.slice(0, 10);
    setNomineeMobile(mobile_number);
    if (isValidMobileNumber(mobile_number)) {
      console.table({
        ApplicantMobileNumber: mobileNumber,
        referenceOneMobile: referenceOneMobile,
        referenceTwoMobile: referenceTwoMobile,
      });
      if (mobile_number === mobileNumber) {
        setNomineeMobileError(true);
        setNomineeMobileErrorMessage(
          "Entered mobile number is same as your own number. Please enter different mobile number."
        );
      } else {
        setNomineeMobileError(false);
        setNomineeMobileErrorMessage("");
      }
    } else {
      setNomineeMobileError(true);
      setNomineeMobileErrorMessage(
        "Kindly input correct Mobile Number of nominee."
      );
    }
  };

  const isValidReferenceThree = useCallback(() => {
    return isValidName(referenceThreeName) && !referenceThreeNameError && relationStatus && !nomineeMobileError && consentCheckbox;
  }, [referenceThreeName, referenceThreeNameError, relationStatus, nomineeMobile, consentCheckbox]);

  // Reference 1
  const [referenceOneName, setReferenceOneName] = useState("");
  const [referenceOneNameError, setReferenceOneNameError] = useState(false);
  const [referenceOneNameErrorMessage, setReferenceOneNameErrorMessage] = useState("Enter a valid name");
  const [referenceOneMobile, setReferenceOneMobile] = useState("");
  const [referenceOneMobileError, setReferenceOneMobileError] = useState(false);
  const [referenceOneMobileErrorMessage, setReferenceOneMobileErrorMessage] =
    useState("Please enter a valid number");
  const [referenceOneVerified, setReferenceOneVerified] = useState(false);

  const updateReferenceOneName = (e) => {
    let value = filterName(e.target.value);
    let referOneName = value.replace(/\s+/g, '').toLowerCase();
    let referTwoName = referenceTwoName.replace(/\s+/g, '').toLowerCase();
    let customerName = `${customerDetails?.Data?.first_name}${customerDetails?.Data?.last_name}`.replace(/\s+/g, '').toLowerCase();
    let customerFullName = `${customerDetails?.Data?.first_name}${customerDetails?.Data?.middle_name}${customerDetails?.Data?.last_name}`.replace(/\s+/g, '').toLowerCase();

    if (isValidName(value) && referOneName !== referTwoName && referOneName !== customerName && referOneName !== customerFullName) {
      setReferenceOneName(value);
      setReferenceOneNameError(false);
    } else {
      setReferenceOneName(value);
      setReferenceOneNameError(true);
    }
  };
  const updateReferenceOneMobile = (e) => {
    let mobile_number = e.target.value.slice(0, 10);
    setReferenceOneMobile(mobile_number);
    if (isValidMobileNumber(mobile_number)) {
      console.table({
        title: "R1",
        mobileNumber: mobileNumber,
        referenceOneMobile: mobile_number,
        referenceTwoMobile: referenceTwoMobile,
      });
      if (mobile_number === mobileNumber) {
        setReferenceOneMobileError(true);
        setReferenceOneMobileErrorMessage(
          "Entered mobile number is same as your own number. Please enter different mobile number."
        );
      } else if (mobile_number === referenceTwoMobile) {
        setReferenceOneMobileError(true);
        setReferenceOneMobileErrorMessage(
          "Kindly input correct Mobile Number of reference."
        );
      } else {
        setReferenceOneMobileError(false);
        setReferenceOneMobileErrorMessage("");
      }
    } else {
      setReferenceOneMobileError(true);
      setReferenceOneMobileErrorMessage(
        "Kindly input correct Mobile Number of reference."
      );
    }
  };

  const isValidReferenceOne = useCallback(() => {
    return (
      isValidName(referenceOneName) &&
      !referenceOneNameError &&
      isValidMobileNumber(referenceOneMobile) &&
      !referenceOneMobileError &&
      consentCheckbox
    );
  }, [
    // referenceOneAddressOne,
    // referenceOneAddressOneError,
    // referenceOneAddressTwo,
    // referenceOneAddressTwoError,
    // referenceOneCity,
    referenceOneMobile,
    referenceOneMobileError,
    referenceOneName,
    referenceOneNameError,
    consentCheckbox,
    // referenceOnePincode,
    // referenceOnePincodeError
  ]);
  useEffect(() => {
    if (isValidReferenceOne()) {
      setReferenceOneVerified(true);
    } else {
      setReferenceOneVerified(false);
    }
  }, [
    // referenceOneAddressOne,
    // referenceOneAddressTwo,
    // referenceOneCity,
    referenceOneMobile,
    referenceOneMobileError,
    referenceOneName,
    referenceOneNameError,
    consentCheckbox,
    // referenceOnePincode,
    // referenceOnePincodeError,
    isValidReferenceOne,
  ]);

  // Reference 2
  const [referenceTwoName, setReferenceTwoName] = useState("");
  const [referenceTwoNameError, setReferenceTwoNameError] = useState(false);
  const [referenceTwoNameErrorMessage, setReferenceTwoNameErrorMessage] = useState("Enter a valid name");
  const [referenceTwoMobile, setReferenceTwoMobile] = useState("");
  const [referenceTwoMobileError, setReferenceTwoMobileError] = useState(false);
  const [referenceTwoMobileErrorMessage, setReferenceTwoMobileErrorMessage] =
    useState("Please enter a valid number");
  const [referenceTwoVerified, setReferenceTwoVerified] = useState(false);
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  // );
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [showShimmer, setShowShimmer] = useState(true);

  useEffect(() => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("ReferenceDetails customerDetails: ", customerDetails);
      setShowShimmer(false);
      // TODO: Handle Staging if needed
      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
        state: {
          customerDetails: customerDetails,
        },
      });
    } else {
      // console.log("ReferenceDetails Ouch customerDetails ", location);
    }
  }, [customerDetails]);

  useEffect(() => {
    // window.scrollTo(0, 0);
    const dummyTimeout = setTimeout(() => {
      // setShowShimmer(false);
    }, 2000);
    return () => clearTimeout(dummyTimeout);
  }, []);

  const updateReferenceTwoName = (e) => {
    let value = filterName(e.target.value);
    let referTwoName = value.replace(/\s+/g, '').toLowerCase();
    let referOneName = referenceOneName.replace(/\s+/g, '').toLowerCase();
    let customerName = `${customerDetails?.Data?.first_name}${customerDetails?.Data?.last_name}`.replace(/\s+/g, '').toLowerCase();
    let customerFullName = `${customerDetails?.Data?.first_name}${customerDetails?.Data?.middle_name}${customerDetails?.Data?.last_name}`.replace(/\s+/g, '').toLowerCase();

    if (isValidName(value) && referTwoName !== referOneName && referTwoName !== customerName && referTwoName !== customerFullName) {
      setReferenceTwoName(value);
      setReferenceTwoNameError(false);
    } else {
      setReferenceTwoName(value);
      setReferenceTwoNameError(true);
    }
    e.target.value = value;
  };
  const updateReferenceTwoMobile = (e) => {
    let mobile_number = e.target.value.slice(0, 10);
    setReferenceTwoMobile(mobile_number);
    if (isValidMobileNumber(mobile_number)) {
      console.table({
        title: "R2",
        mobileNumber: mobileNumber,
        referenceOneMobile: referenceOneMobile,
        referenceTwoMobile: mobile_number,
      });
      if (mobile_number === mobileNumber) {
        setReferenceTwoMobileError(true);
        setReferenceTwoMobileErrorMessage(
          "Entered mobile number is same as your own number. Please enter different mobile number."
        );
      } else if (mobile_number === referenceOneMobile) {
        setReferenceTwoMobileError(true);
        setReferenceTwoMobileErrorMessage(
          "Kindly input correct Mobile Number of reference."
        );
      } else {
        setReferenceTwoMobileError(false);
        setReferenceTwoMobileErrorMessage("");
      }
    } else {
      setReferenceTwoMobileError(true);
      setReferenceTwoMobileErrorMessage(
        "Kindly input correct Mobile Number of reference."
      );
    }
  };
  const isValidReferenceTwo = useCallback(() => {
    return (
      isValidName(referenceTwoName) &&
      !referenceTwoNameError &&
      isValidMobileNumber(referenceTwoMobile) &&
      !referenceTwoMobileError &&
      consentCheckbox
      // isValidAddress(referenceTwoAddressOne) &&
      // !referenceTwoAddressOneError &&
      // isValidAddress(referenceTwoAddressTwo) &&
      // !referenceTwoAddressTwoError &&
      // isValidPincode(referenceTwoPincode) &&
      // !referenceTwoPincodeError &&
      // isValidCity(referenceTwoCity)
    );
  }, [
    // referenceTwoAddressOne,
    // referenceTwoAddressOneError,
    // referenceTwoAddressTwo,
    // referenceTwoAddressTwoError,
    // referenceTwoCity,
    referenceTwoMobile,
    referenceTwoMobileError,
    referenceTwoName,
    referenceTwoNameError,
    consentCheckbox,
    // referenceTwoPincode,
    // referenceTwoPincodeError
  ]);

  useEffect(() => {
    if (isValidReferenceTwo()) {
      setReferenceTwoVerified(true);
    } else {
      setReferenceTwoVerified(false);
    }
  }, [
    isValidReferenceTwo,
    // referenceTwoAddressOne,
    // referenceTwoAddressTwo,
    // referenceTwoCity,
    referenceTwoMobile,
    referenceTwoMobileError,
    referenceTwoName,
    referenceTwoNameError,
    consentCheckbox,
    // referenceTwoPincode,
    // referenceTwoPincodeError
  ]);

  useEffect(() => {
    if (
      isValidMobileNumber(referenceOneMobile) &&
      isValidMobileNumber(referenceTwoMobile)
    ) {
      if (referenceOneMobile !== referenceTwoMobile) {
        if (referenceOneMobile === mobileNumber) {
          setReferenceOneMobileError(true);
          setReferenceOneMobileErrorMessage(
            "Entered mobile number is same as your own number. Please enter different mobile number."
          );
        } else {
          setReferenceOneMobileError(false);
          setReferenceOneMobileErrorMessage("");
        }
        if (referenceTwoMobile === mobileNumber) {
          setReferenceTwoMobileError(true);
          setReferenceTwoMobileErrorMessage(
            "Entered mobile number is same as your own number. Please enter different mobile number."
          );
        } else {
          setReferenceTwoMobileError(false);
          setReferenceTwoMobileErrorMessage("");
        }
      } else {
        if (
          referenceOneMobile === mobileNumber &&
          referenceTwoMobile === mobileNumber
        ) {
          setReferenceOneMobileError(true);
          setReferenceOneMobileErrorMessage(
            "Entered mobile number is same as your own number. Please enter different mobile number."
          );
          setReferenceTwoMobileError(true);
          setReferenceTwoMobileErrorMessage(
            "Entered mobile number is same as your own number. Please enter different mobile number."
          );
        } else {
          setReferenceOneMobileError(true);
          setReferenceOneMobileErrorMessage(
            "Entered mobile number is same as that of other reference. Please enter different mobile number."
          );
          setReferenceTwoMobileError(true);
          setReferenceTwoMobileErrorMessage(
            "Entered mobile number is same as that of other reference. Please enter different mobile number."
          );
        }
      }
    }
  }, [mobileNumber, referenceOneMobile, referenceTwoMobile]);

  const isValidScreen = useCallback(() => {
    return referenceOneVerified && referenceTwoVerified;
  }, [referenceOneVerified, referenceTwoVerified]);
  useEffect(() => {
    if (isValidScreen()) {
      setOnSubmitButtonDisabled(true);
    } else {
      setOnSubmitButtonDisabled(false);
    }
  }, [isValidScreen, referenceOneVerified, referenceTwoVerified]);

  const handleOnSubmit = async () => {
    moengage.track_event("reference_details",{
      "journey name": customerDetails.source,
      reference_One_name: referenceOneName,
      reference_One_mobile: referenceOneMobile,
      reference_Two_name: referenceTwoName,
      reference_Two_mobile: referenceTwoMobile,
    })
    // setModal("LOADING");
    var payload = {
      name1: referenceOneName,
      mobile_number1: referenceOneMobile,
      name2: referenceTwoName,
      mobile_number2: referenceTwoMobile,
      current_stage: customerDetails.stage,
      cust_ins_choice: customerDetails.Data.cust_ins_choice,
      nominee_name: referenceThreeName,
      nominee_relationship: relationStatus,
      nominee_mobile: nomineeMobile
    };
    try {
      setShowShimmer(true);
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest("/" + customerDetails.source + REFERENCE_DETAILS, formData);
      setShowShimmer(false);
      // console.log("Response: ", response);
      if (response.response.Success) {
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
        // navigate("/review", {
        //   replace: true,
        //   state: {
        //     customerDetails: customerDetails,
        //     // application_form_number: customerDetails.application_form_number
        //   },
        // });
		   updateLead(customerDetails.source, 103, customerDetails.application_form_number)
      } else {
        if (response.response.Message === "Nominee should not contain reference and personal name") {
          setReferenceThreeNameError(true)
          setReferenceThreeNameErrorMessage("Nominee should not contain reference and personal name")
        }
        if (response.response.Message === "Reference names should not be same") {
          setReferenceOneNameError(true)
          setReferenceTwoNameError(true)
          setReferenceOneNameErrorMessage("Reference names should not be same")
          setReferenceTwoNameErrorMessage("Reference names should not be same")
        }
        if (response.response.Message === "Reference mobile number should not be same") {
          setReferenceOneMobileError(true)
          setReferenceTwoMobileError(true)
          setReferenceOneMobileErrorMessage("Reference mobile number should not be same")
          setReferenceTwoMobileErrorMessage("Reference mobile number should not be same")
        }
        if (response.response.Message === "Nominee mobile cannot be same as customer mobile") {
          setNomineeMobileError(true);
          setNomineeMobileErrorMessage(
            "Nominee mobile cannot be same as customer mobile"
          );
        }
      }
    } catch (error) {
      setShowShimmer(false);
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
    }
  };
  
  const updateConsentCheckbox = () => {
    setReferenceConsent(!referenceConsent);
    setConsentCheckbox(!consentCheckbox);
  };

  const handleProceedClick = async () => {
    const payload = {
      reference_consent: referenceConsent,
    };
    const src = customerDetails.source;
    await userConsentStatus(payload, src);
    await handleOnSubmit();
  }

  return (
    <>
      <ProgressBar showProgress={true} currentStep={6} />
      <AfterLoginLayoutWrapper>
        <Loading
          open={modal === "LOADING_CKYC"}
          msg="Please wait while we verify your details."
        />
        <Loading open={modal === "LOADING"} />
        <Modal open={modal === "TECHNICAL_ERROR"} onClose={() => setModal("")}>
          <ErrorModal />
        </Modal>
        <ReferenceDetailsWrapper className="first-child">
          <div className="reference-form-title">
            <ShimmerPlaceholder
              visible={showShimmer}
              width="13em"
              height="2.5em"
            />
            <Title
              id="pageTitle"
              className="pageTitle"
              text={`Reference Details`}
              icon={
                <>
                  <img
                    src={referenceTitleIcon}
                    alt="titleIcon.svg"
                    height="22"
                    width="22"
                  />
                </>
              }
              visible={!showShimmer}
              clickable={false}
            />
            <ShimmerPlaceholder
              visible={showShimmer}
              width="13em"
              height="2.5em"
              marginTop="-0.5em"
            />
            <SubTitle
              visible={!showShimmer}
              text={"Help us with two references"}
            />
          </div>
          <form className="reference-form">
            <div className="reference-form-sub-heading">
              <ShimmerPlaceholder
                visible={showShimmer}
                width="6em"
                height="1.5em"
                justifyContent="flex-start"
              />
              <p style={{ display: showShimmer ? "none" : "", margin: 0 }}>
                Reference 1
              </p>
            </div>
            <div className="reference-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                value={referenceOneName}
                on_change={updateReferenceOneName}
                error={referenceOneNameError}
                error_message={referenceOneNameErrorMessage}
                visible={!showShimmer}
                type={"text"}
                label={"Name"}
              />
            </div>
            <div className="reference-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                value={referenceOneMobile}
                on_change={updateReferenceOneMobile}
                error={referenceOneMobileError}
                error_message={referenceOneMobileErrorMessage}
                visible={!showShimmer}
                type={"number"}
                label={"Mobile Number"}
              />
            </div>
            <div className="reference-form-sub-heading">
              <ShimmerPlaceholder
                visible={showShimmer}
                width="6em"
                height="1.5em"
                justifyContent="flex-start"
              />
              <p style={{ display: showShimmer ? "none" : "", margin: 0 }}>
                Reference 2
              </p>
            </div>
            <div className="reference-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                value={referenceTwoName}
                on_change={updateReferenceTwoName}
                error={referenceTwoNameError}
                error_message={referenceTwoNameErrorMessage}
                visible={!showShimmer}
                type={"text"}
                label={"Name"}
              />
            </div>
            <div className="reference-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                value={referenceTwoMobile}
                on_change={updateReferenceTwoMobile}
                error={referenceTwoMobileError}
                error_message={referenceTwoMobileErrorMessage}
                visible={!showShimmer}
                type={"number"}
                label={"Mobile Number"}
              />
            </div>
            {customerDetails?.Data?.cust_ins_choice =="YES"  ? (
              <>
                <div className="reference-form-sub-heading">
                  <ShimmerPlaceholder
                    visible={showShimmer}
                    width="6em"
                    height="1.5em"
                    justifyContent="flex-start"
                  />
                  <p style={{ display: showShimmer ? "none" : "", margin: 0 }}>
                    Nominee Details for Insurance
                  </p>
                </div>
                <div className="reference-form-input">
                  <ShimmerPlaceholder visible={showShimmer} />
                  <FloatingInput
                    value={referenceThreeName}
                    on_change={updateReferenceThreeName}
                    error={referenceThreeNameError}
                    error_message={referenceThreeNameErrorMessage}
                    visible={!showShimmer}
                    type={"text"}
                    label={"Name"}
                  />
                </div>
                <div className="reference-form-input">
                  <FloatingInput
                    visible={!showShimmer}
                    // on_change={(e) => {
                    //   dropDownChange(e.target.value);
                    // }}
                    type={"text"}
                    value={relationStatus}
                    // error={maritalStatusError}
                    error_message="Select status"
                    label={"Relation Status"}
                    disabled={relationStatusDisabled}
                    options={dropDownOptions}
                  />
                </div>
                <div className="reference-form-input">
                  <ShimmerPlaceholder visible={showShimmer} />
                  <FloatingInput
                    value={nomineeMobile}
                    on_change={updateNomineeMobile}
                    error={nomineeMobileError}
                    error_message={nomineeMobileErrorMessage}
                    visible={!showShimmer}
                    type={"number"}
                    label={"Mobile Number"}
                  />
                </div>
              </>
            ) : (
              <></>
            )}
          </form>
          <div style={{ display: showShimmer ? "none" : "flex", marginTop: "20px" }}>
            <CheckField
              id="basic-ckeckfield"
              checked={consentCheckbox}
              label="I hereby give my consent to share contact details of two references that ABCL or any of its authorized representatives/service providers may contact or reach out to, at its sole option, either for my verification or background check before disbursement of the loan and/or at any time post disbursement of loan in case I am not reachable/approachable due to any reason. I also affirm that I am authorized to share below mentioned reference details."
              style={{
                fontSize: "1.4rem",
              }}
              onClick={updateConsentCheckbox}
            />
          </div>
          <div className="bottomDiv only-btn">
            {showShimmer ? (
              <>
                <ShimmerPlaceholder visible={showShimmer} width="9em" />
              </>
            ) : (
              <div className={"reference-form-img"}>
                <Button
                  id="Btn"
                  className="Btn"
                  mobile={isMobile}
                  disabled={
                    !(
                      isValidReferenceOne() &&
                      isValidReferenceTwo() &&
                      (customerDetails?.Data?.cust_ins_choice == "YES"
                        ? isValidReferenceThree()
                        : true)
                    )
                  }
                  text={"Proceed"}
                  onClick={() => {
                    if (
                      isValidReferenceOne() &&
                      isValidReferenceTwo() &&
                      (customerDetails?.Data?.cust_ins_choice == "YES"
                        ? isValidReferenceThree()
                        : true)
                    ) {
                      // history.replace({
                      //   pathname: `/additional`,
                      //   // pathname: `/selfie`,
                      //   search: location.search,
                      // });
                      handleProceedClick();
                    }
                  }}
                />
              </div>
            )}
          </div>
        </ReferenceDetailsWrapper>
        {/* <div className="summary-container">
          <Summary stage="ADDITIONAL_DETAILS" />
        </div> */}
      </AfterLoginLayoutWrapper>
    </>
  );
};

export default ReferenceDetails;
